import { FleekError } from './FleekError';

type SiteCreationFailedErrorOptions = Record<string, never>;

export class SiteCreationFailedError extends FleekError<SiteCreationFailedErrorOptions> {
  public name = 'SiteCreationFailedError';

  constructor() {
    super({});
  }

  toString = () => `Site creation failed.`;
}
